import { useRef } from 'react';
import { CreateContent } from '../CreateContent/CreateContent.jsx';
import { CONTENT_ITEM_KEYS } from '../CreateContent/constants.js';

/**
 * Управляемый редактор контента поверх CreateContent.
 * value — массив блоков в формате API: [{ guid, discriminator, content | imgPath | images | ... }]
 * onChange(nextItems) — новый массив (с учётом порядка после перетаскивания).
 *
 * CreateContent читает initialValues только при монтировании —
 * при смене сущности/языка передавайте другой key.
 */
export const ContentEditor = ({ value = [], onChange, label }) => {
  // CreateContent запоминает часть обработчиков при первом рендере — читаем актуальные данные через ref
  const valueRef = useRef(value);
  const onChangeRef = useRef(onChange);
  valueRef.current = value;
  onChangeRef.current = onChange;

  const emit = (next) => onChangeRef.current?.(next);

  const handleAdd = (item) => {
    emit([...valueRef.current, { guid: item.id, discriminator: item.type }]);
  };

  const handleChange = (item) => {
    emit(
      valueRef.current.map((i) => {
        if (i.guid !== item.id) return i;
        const key = CONTENT_ITEM_KEYS[item.type];
        if (item.type === 'ImageSliderContentItem') {
          return { ...i, images: item.content };
        }
        // При смене файла CreateContent выдаёт блоку новый Guid — файл уйдёт под ним
        const guid = item.type === 'TextContentItem' ? item.id : item.newGuid || item.id;
        return { ...i, guid, [key]: item.content };
      }),
    );
  };

  const handleDelete = (guid) => {
    emit(valueRef.current.filter((i) => i.guid !== guid));
  };

  const handleReorder = (orderedGuids) => {
    const byGuid = new Map(valueRef.current.map((i) => [i.guid, i]));
    const ordered = orderedGuids.map((guid) => byGuid.get(guid)).filter(Boolean);
    const rest = valueRef.current.filter((i) => !orderedGuids.includes(i.guid));
    emit([...ordered, ...rest]);
  };

  return (
    <CreateContent
      label={label}
      initialValues={value}
      onAdd={handleAdd}
      onChange={handleChange}
      onDelete={handleDelete}
      onReorder={handleReorder}
    />
  );
};
